const roles: Record<string, string> = {
  owner: "所有者",
  maintainer: "维护者",
  supervisor: "审核员",
  worker: "标注员",
};

const stages: Record<string, string> = {
  annotation: "标注",
  validation: "审核",
  acceptance: "验收",
};

const jobStatuses: Record<string, string> = {
  "annotation:new": "待标注",
  "annotation:in_progress": "标注中",
  "annotation:rejected": "退回修改",
  "validation:completed": "待审核",
  "acceptance:completed": "已验收",
};

const taskStatuses: Record<string, string> = {
  annotation: "标注阶段",
  validation: "待审核",
  completed: "已验收",
};

const verdicts: Record<string, string> = {
  accepted: "审核通过",
  rejected: "退回修改",
};

export const roleLabel = (value?: string) => value ? roles[value] ?? "未知角色" : "—";
export const stageLabel = (value?: string) => value ? stages[value] ?? "未知阶段" : "—";
export const jobStatusLabel = (stage?: string, state?: string) => {
  if (!stage || !state) return "—";
  return jobStatuses[`${stage}:${state}`] ?? "未知工作状态";
};
export const taskStatusLabel = (value?: string) => value ? taskStatuses[value] ?? "未知任务状态" : "—";
export const verdictLabel = (value?: string) => value ? verdicts[value] ?? "未知结论" : "—";
